import React, { useContext, useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Label } from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { LabelProps, TableHeaderProps } from "../../../../../../utils/types";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import {
  HEADER_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../../styles/Variables";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import Assign from "../../../../../../images/Assign.svg";
import Modal from "react-modal";
import Conclude from "./Conclude";
import {
  AddModalStyles,
  ViewModalStyles,
} from "../../../../../../styles/CustomModalStyles";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import SelectedSuppliers from "../SelectedSuppliers";
import Accepted from "../../../../../../images/ApprovedStatus.svg";
import {
  AcceptReject,
  FromStatus,
  LicenseTypes,
  MaterialRequestStatus,
  Operation,
  PageFor,
  TransStatus,
} from "../../../../../../utils/Enum.types";
import Rejected from "../../../../../../images/RejectedStatus.svg";
import SaveasProgress from "../../../../../../images/Save as Progress.svg";
import Close from "../../../../../../images/Close.svg";
import { viewMaterialForm } from "../../../../../../utils/formTypes";
import {
  ApproveOrRejectMrfResult,
  ApproveOrRejectMrfVars,
  AtsMrfTrnEdge,
  AtsMrfTrnOrderField,
  GetMrfTrnsResult,
  GetMrfTrnsVars,
  MrfTrnQueryType,
} from "../queries/types";
import {
  getModifiedScrollHeight,
  toInputStandardDate,
  toIsoDate,
  toStandardCase,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GetMrfTrns } from "../queries/queries";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../../context/context";
import {
  debouncedDelay,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import LoggedEmployee from "../../../../../../customComponents/LoggedEmployee";
import { payloadTypes } from "../../../../../../context/reducer";
import { ApproveOrRejectMrf } from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../../../customComponents/MessageModal";
import MRFtoPOEntry from "../../mrf/MRFtoPOEntry";
import Mrf from "../../../../../../images/MrfToPo.svg";
import LoadingModal from "../../../../../pages/LoadingModal";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import Navbar from "../../../../../common/layout/Navbar";
import { useHotKey } from "../../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../../utils/Enum.keys";
import useFormJson from "../../../../../../json/useFormJson";
import { useDebounce } from "../../../../../../customHooks/useDebounce";
interface Props {
  type: MaterialRequestStatus;
  pageType: PageFor;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

interface totalsType {
  reqTotal: number;
  approxRate: number;
  taxableValue: number;
  tax: number;
  netValue: number;
  acceptQty: number;
}
const ViewPendingStatus = ({ type, pageType, setModalFlag }: Props) => {
  const navigate = useNavigate();
  const [conclude, setConclude] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState(false);
  const [viewMrfToPo, setViewMrfToPo] = useState(false);

  const { user_details } = useLoggedInUserDetails();
  const { viewMaterialRequestOrder } = useFormJson();
  const [Approved, { loading: ApproveOrRejectMrfLoading }] = useMutation<
    ApproveOrRejectMrfResult,
    ApproveOrRejectMrfVars
  >(ApproveOrRejectMrf, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [message, setMessage] = useState(emptyMessage);
  const [poEntry, setPoEntry] = useState(false);

  const { serverDate } = useServerDateandTime();



  const { state, dispatch } = useContext(AppContext);

  const { customer_id, company_id, mrf_id } = useUrlParams();

  const [reqForm, setReqForm] = useState<viewMaterialForm>({
    reqDate: "",
    mrfNo: "",
    narration: "",
    raisedBy: "",
    refNo: "",
    remarks: "",
    scan_copy: "",
    sub_name: "",
    materialReqFor: "",
  });

  const [items, setItems] = useState<AtsMrfTrnEdge[]>([]);

  const [GetTransactions, { data, loading, fetchMore }] = useLazyQuery<
    GetMrfTrnsResult,
    GetMrfTrnsVars
  >(GetMrfTrns);

  const { Purchase } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] = Purchase.Material.View.map(
    (header) => {
      const dynamicHeader: TableHeaderProps = {
        headerName: header.headerName,
        field: header.field,
        headerAlign: header.headerAlign as GridAlignment,
        align: header.align as GridAlignment,
        flex: header.flex,
        cellClassName: header.cellClassName,
        hideable: header.hideable,
      };

      if (header.field === "accepted") {
        dynamicHeader.renderCell = (params) => {
          return params.value === TransStatus.ACCEPTED ? (
            <img
              src={Accepted}
              alt="Accepted"
              className="view-pending__tableblock--pending"
            />
          ) : params.value === TransStatus.ACCEPTED ? (
            <img
              src={Rejected}
              alt="Rejected"
              className="view-pending__tableblock--pending"
            />
          ) : (
            <span>-</span>
          );
        };
      }

      return dynamicHeader;
    }
  );

  const columns: GridColDef[] = [
    ...dynamicHeaders,
    ...(pageType === PageFor.GENERAL
      ? [
          {
            headerName: "Actions",
            field: "actions",
            headerAlign: HEADER_TEXT_ALIGN,
            renderCell: (params: any) => {
              return (
                <>
                  <button
                    className="view-pending__tableblock--actions"
                    onClick={() => {
                      dispatch({
                        type: payloadTypes.SET_MRFTRANS_ID,
                        payload: {
                          mrfTransId: params.row.mrf_trns_id,
                        },
                      });

                      setConclude(!conclude);
                    }}
                  >
                    Conclude
                    <img src={Assign} alt="" />
                  </button>
                  {/* <button
                className="view-pending__tableblock--update"
                onClick={() => setConclude(!conclude)}
              >
                Update
                <img src={Edit} alt="" />
              </button> */}
                </>
              );
            },
          },
        ]
      : []),
  ];
  const totals: totalsType = useMemo(() => {
    return items.reduce(
      (acc: totalsType, itm: AtsMrfTrnEdge) => {
        const netValue =
          (Number(itm.node.tax) / 100) *
          (Number(itm.node.reqQty) * Number(itm.node.approxRate));
        acc.reqTotal = acc.reqTotal + Number(itm.node.reqQty);
        acc.approxRate = acc.approxRate + Number(itm.node.approxRate);
        acc.taxableValue = acc.taxableValue + Number(itm.node.taxable);
        acc.tax = acc.tax + Number(itm.node.tax);
        acc.netValue = acc.netValue + netValue;
        acc.acceptQty = acc.acceptQty + Number(itm.node.acceptQty);

        return acc;
      },
      {
        reqTotal: 0,
        approxRate: 0,
        taxableValue: 0,
        tax: 0,
        netValue: 0,
        acceptQty: 0,
      }
    );
  }, [items]);

  const getRow = () => {
    if (items.length) {
      return [
        {
          id: [],
          item_code: [],
          uom: [],
          description: [],
          present_stock: "Total",
          required_qty: totals.reqTotal,
          approx_rate: totals.approxRate,
          taxable_amt: totals.taxableValue,
          tax: [],
          net_value: totals.netValue,
          priority: [],
          need_before: [],
          prefered_vendor: [],
          used_for: [],
          remark: [],
          accepted: "Total",
          accepted_qty: totals.acceptQty,
          rfq_date: [],
          rfq_sent: [],
          company_remark: [],
          actions: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "required_qty":
        case "approx_rate":
        case "taxable_amt":
        case "net_value":
        case "accepted_qty":
          return "total-count";
        case "present_stock":
        case "accepted":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };
  useEffect(() => {
    if (customer_id && state.ActiveFinYr && mrf_id)
      GetTransactions({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          mrfId: mrf_id,
          queryType: MrfTrnQueryType.ALL_ITEMS,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfTrnOrderField.SL_NO,
          },
          name: debouncedSearch,
          
        },
      }).then(({ data }) => {
        if (data && data.GetMrfTrns) {
          if (data.GetMrfTrns.edges.length) {
            const mrfDetails = data.GetMrfTrns.edges[0].node.mrf;
            setReqForm({
              reqDate: mrfDetails.mrfDate,
              mrfNo: mrfDetails.mrfNo,
              narration: mrfDetails.remarks,
              raisedBy: `${mrfDetails.raisedByUserDetails.name}`,
              refNo: mrfDetails.refNo,
              remarks: mrfDetails.remarks,
              scan_copy: "",
              sub_name: mrfDetails.subsidiary.name,
              materialReqFor: mrfDetails.subsidiary.name,
            });
          }
        }
      });
  }, [
    GetTransactions,
    customer_id,
    mrf_id,
    state.ActiveFinYr,
    data,
    debouncedSearch,
  ]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetMrfTrns.edges;
              const pageInfo = fetchMoreResult.GetMrfTrns.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetMrfTrns.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetMrfTrns: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetMrfTrns.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && items.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [items]);
  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetMrfTrns.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetMrfTrns.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  const rowData = useMemo(() => {
    return items.map((itm, index) => {
      const netValue =
        Number(itm.node.reqQty) *
        Number(itm.node.approxRate) *
        (Number(itm.node.tax) / 100);
      return {
        id: index + 1,
        item_code: `${itm.node.item.desc} ${
          itm.node.item.code.length ? `(${itm.node.item.code})` : ""
        } `,
        uom: itm.node.item.uom,
        description: itm.node.udfItemDesc,
        present_stock: itm.node.presentStk,
        required_qty: itm.node.reqQty,
        approx_rate: itm.node.approxRate,
        taxable_amt: itm.node.taxable,
        tax: itm.node.tax,
        net_value: netValue,
        priority: itm.node.priority,
        need_before: toStandardDate(itm.node.trnNeedBefore),
        prefered_vendor: itm.node.preferedSupplierIds,
        used_for: itm.node.mrf.subsidiary.name,
        remark: itm.node.mrf.remarks,
        accepted: itm.node.acceptStatus,
        accepted_qty: itm.node.acceptQty,
        accepted_remark: itm.node.acceptRemarks,
        mrf_trns_id: itm.node.id,
      };
    });
  }, [items]);
  const handleSubmit = async (type: AcceptReject) => {
    
    if (customer_id && state.ActiveFinYr && mrf_id) {
      Approved({
        variables: {
          customerId: customer_id,
          finYrId: state.ActiveFinYr?.id,
          mrfId: mrf_id,
          user_details,
          todaysDate: toIsoDate(serverDate),
          
          input: {
            acceptQty: totals.acceptQty,
            acceptTaxable: totals.taxableValue,
            acceptTax: totals.tax,
            acceptValue: totals.netValue,
            acceptStatus:
              type === AcceptReject.ACCEPT
                ? FromStatus.APPROVED
                : FromStatus.REJECTED,
            acceptRemarks: reqForm.narration,
          },
        },
      }).then(({ data }) => {
        if (data && data.ApproveOrRejectMrf) {
          setMessage({
            flag: true,
            message: `${toStandardCase(type)} successfully`,
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_VIEW
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MATERIAL_REQUEST_VIEW,
      JSON.stringify(newModel)
    );
  };

  useHotKey({
    handleFunc: () => {
      navigate(`/assets/purchase/material/pending/view`);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });

  const handleClear = () => {
    setReqForm({
      ...reqForm,
      narration: "",
    });
  };

  return (
    <>
      <>
        {pageType === PageFor.GENERAL && (
          <Navbar NavType={LicenseTypes.COMPANY} />
        )}

        {pageType === PageFor.MODAL ? (
          <div className="view-pending__title">
            <Title>
              {`View ${
                type === MaterialRequestStatus.APPROVED
                  ? "Approved"
                  : type === MaterialRequestStatus.REJECTED
                  ? "Rejected"
                  : type === MaterialRequestStatus.PENDING
                  ? "Pending"
                  : type === MaterialRequestStatus.INPROGRESS
                  ? "In Progress"
                  : ""
              } Request`}
            </Title>
            <img src={Close} alt="Close" onClick={() => setModalFlag(false)} />
          </div>
        ) : (
          <>
            <Title>View Material Request</Title>
          </>
        )}
      </>
      {pageType === PageFor.VIEW && (
        <b className="view-pending__initiated">MRF to PO Initiated</b>
      )}

      <div
        className={`view-pending${
          pageType === PageFor.GENERAL
            ? ""
            : pageType === PageFor.VIEW
            ? "__view"
            : "__modal"
        }`}
      >
        <div className="view-pending__filterblock row g-0">
          <div className="col view-pending__filterblock--frame">
            <div className="label-grid">
              {viewMaterialRequestOrder.leftForm.map(
                (res: LabelProps, key: React.Key) => {
                  return (
                    <React.Fragment key={key}>
                      <Label>{res.labelName}</Label>
                      <Input
                        disabled
                        name={res.inputName}
                        value={reqForm[res.inputName]}
                      />
                    </React.Fragment>
                  );
                }
              )}
            </div>
          </div>
          <div className="col view-pending__filterblock--frame">
            <div className="view-pending__filterblock--frame--grid">
              <Label>Date Request Made</Label>
              <Input
                type="date"
                disabled
                value={toInputStandardDate(reqForm.reqDate as string)}
              />
            </div>
            <div className=" view-pending__filterblock--flex">
              <div className="view-pending__filterblock--grid">
                <Label>MRF Raised By</Label>
                <Input disabled value={reqForm.raisedBy} />
              </div>
              <div className="view-pending__filterblock--grid">
                <Label>MR Scan Copy</Label>
                <Input disabled />
              </div>
            </div>
            <div className="view-pending__filterblock--frame--grid">
              <Label>Remarks</Label>
              <Input disabled value={reqForm.remarks} />
            </div>
          </div>
        </div>
        <div className="view-pending__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rowData}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "prefered_vendor") {
                setSelectedSuppliers(!selectedSuppliers);
              }
            }}
            disableRowSelectionOnClick
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              pinnedColumns: {
                left: ["id", "item_code"],
                right: [
                  "accepted",
                  "accepted_qty",
                  "rfq_date",
                  "rfq_sent",
                  "accepted_remark",
                  "actions",
                ],
              },
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
          />
        </div>
        <div className="view-pending__datablock">
          <div className="row g-0">
            <div className="col label-grid">
              <Label>MRF Acceptance Date</Label>
              <Input type="date" value={toInputStandardDate(serverDate)} />
            </div>
            <div className="col view-pending__datablock-grid">
              <Label>MRF Acceptance made by</Label>
              <LoggedEmployee />
            </div>
          </div>
          <div className="view-pending__datablock--grid">
            <Label>Narration</Label>
            <TextArea
              rows={3}
              onChange={(e) => {
                setReqForm({
                  ...reqForm,
                  narration: e.target.value,
                });
              }}
            />
          </div>
        </div>
        {pageType === PageFor.GENERAL ? (
          <div className="row g-0">
            <div className="col">
              <Button
                mode="approve"
                onClick={() => {
                  handleSubmit(AcceptReject.ACCEPT);
                }}
              />
              <Button
                mode="reject"
                onClick={() => {
                  handleSubmit(AcceptReject.REJECT);
                }}
              />
              <Button mode="clear" onClick={handleClear} type="button" />
              <Button mode="back" onClick={() => navigate(-1)} type="button" />
            </div>
            <div className="col-3 flex-end view-pending__save-as">
              <Button>
                <img src={SaveasProgress} alt="" /> Save as Progress
              </Button>
            </div>
          </div>
        ) : (
          <>
            {type === MaterialRequestStatus.PENDING && (
              <Button
                mode="addnew"
                onClick={() =>
                  navigate(
                    `/${customer_id}/company/${company_id}/purchase/material/pending/view`
                  )
                }
              >
                &nbsp;Details
              </Button>
            )}
            {type === MaterialRequestStatus.APPROVED &&
            pageType === PageFor.MODAL ? (
              <Button onClick={() => setPoEntry(!poEntry)}>
                <img src={Mrf} alt="" />
                MRF to Purchase Order
              </Button>
            ) : null}
            {pageType === PageFor.VIEW && (
              <Button mode="view" onClick={() => setViewMrfToPo(!viewMrfToPo)}>
                {" "}
                Details of MRF to PO
              </Button>
            )}

            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </>
        )}
      </div>
      <Modal isOpen={conclude} ariaHideApp={false} style={AddModalStyles}>
        <Conclude setModalFlag={setConclude} />
      </Modal>
      <CustomDrawer
        anchor="right"
        open={selectedSuppliers}
        onClose={() => setSelectedSuppliers(!selectedSuppliers)}
      >
        <SelectedSuppliers
          setModalFlag={setSelectedSuppliers}
          pageType={MaterialRequestStatus.PENDING}
          handleClose={() => {}}
        />
      </CustomDrawer>
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <Modal isOpen={poEntry} style={ViewModalStyles} ariaHideApp={false}>
        <MRFtoPOEntry setModalFlag={setPoEntry} pageType={PageFor.GENERAL} />
      </Modal>
      <Modal isOpen={viewMrfToPo} style={ViewModalStyles} ariaHideApp={false}>
        <MRFtoPOEntry setModalFlag={setViewMrfToPo} pageType={PageFor.VIEW} />
      </Modal>
      <LoadingModal flag={loading || ApproveOrRejectMrfLoading} />
    </>
  );
};

export default ViewPendingStatus;
